'use client'

import { BuilderBlocks } from '@builder.io/react'

import { type NutritionalFactsItem } from '@src/components/NutritionalFacts/NutritionalFacts.props'
import { cn } from '@src/utils/tailwind'

export interface NutritionalFactsContentProps {
  nutritionalInfo: NutritionalFactsItem
  singleColumn?: boolean
  builderBlock?: any
}

export const NutritionalFactsContent = (props: NutritionalFactsContentProps) => {
  const { nutritionalInfo, builderBlock, singleColumn } = props
  const { tableItems, flavorName, blocksRight, blocksTop, blocksBottom } = nutritionalInfo ?? {}

  const renderTable = () => {
    return (
      <div className="flex flex-col">
        {tableItems?.map((item, i) => {
          const isHeader = item.cellType === 'header'
          const isBody = item.cellType === 'body'
          return (
            <div
              key={`${flavorName}-${i}`}
              className={cn('flex gap-4', {
                'border-b-[6px] border-bodi-black-text text-bodi-green-deep-500 pt-2': isHeader,
                'border-b border-bodi-gray-butters text-bodi-black-text py-1': isBody,
              })}
            >
              <div className="flex-1 font-medium">
                <BuilderBlocks
                  key={`${flavorName}-${i}-content`}
                  parentElementId={builderBlock?.id}
                  dataPath={`component.options.item.${flavorName}.${i}.content`}
                  blocks={item.content}
                />
              </div>
              <div className="flex gap-4">
                {item.columns.map((column, j) => {
                  return (
                    <BuilderBlocks
                      key={`${flavorName}-${i}-${j}`}
                      parentElementId={builderBlock?.id}
                      dataPath={`component.options.column.${flavorName}.${i}.${j}.content`}
                      blocks={column.content}
                      style={{
                        minWidth: '28px',
                      }}
                    />
                  )
                })}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div
      className={cn('relative flex flex-col gap-10 *:flex-1', {
        'lg:flex-col': singleColumn,
        'lg:flex-row': !singleColumn,
      })}
    >
      <div className="flex flex-col">
        <BuilderBlocks
          parentElementId={builderBlock?.id}
          dataPath={`component.options.${flavorName}.top.content`}
          blocks={blocksTop}
        />
        {renderTable()}
        <BuilderBlocks
          parentElementId={builderBlock?.id}
          dataPath={`component.options.${flavorName}.bottom.content`}
          blocks={blocksBottom}
        />
      </div>
      {!singleColumn && (
        <BuilderBlocks
          parentElementId={builderBlock?.id}
          dataPath={`component.options.${flavorName}.right.content`}
          blocks={blocksRight}
        />
      )}
    </div>
  )
}
